/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R8_PurposeInputs */

const tr_cerez_s3_r8_purpose = /** @type {(inputs: Cerez_S3_R8_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare istek-tanımlayıcı (rate-limit)`)
};

const en_cerez_s3_r8_purpose = /** @type {(inputs: Cerez_S3_R8_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare request identifier (rate limit)`)
};

const de_cerez_s3_r8_purpose = /** @type {(inputs: Cerez_S3_R8_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare-Anfragekennung (Rate-Limit)`)
};

const ru_cerez_s3_r8_purpose = /** @type {(inputs: Cerez_S3_R8_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор запроса Cloudflare (ограничение частоты)`)
};

/**
* | output |
* | --- |
* | "Cloudflare request identifier (rate limit)" |
*
* @param {Cerez_S3_R8_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r8_purpose = /** @type {((inputs?: Cerez_S3_R8_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R8_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r8_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r8_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r8_purpose(inputs)
	return tr_cerez_s3_r8_purpose(inputs)
});